import { SET_CONVERGENCE_MODAL } from './types';

export function setConvergenceModal(value: boolean) {
  return {
    type: SET_CONVERGENCE_MODAL,
    payload: value,
  };
}
